import { settingsAtom } from "@framework/shared/atoms";
import { trans } from "@mongez/localization";
import { formatLocalizedNumber } from "./locale-formatters";

export function money(amount: number) {
  const currency = settingsAtom.get("general")?.currency || "EGP";

  if (amount === undefined) return "";

  if (typeof amount === "number") {
    return `${formatLocalizedNumber(amount)} ${trans(currency)}`;
  }

  return `${amount} ${trans(currency)}`;
}
